import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { PrintButton } from '@bibliocommons/print';
import SortDropDown from 'app/components/shared/SortDropDown';
import Pagination from '@bibliocommons/pagination';

import FacetDrawerToggle from '../../deprecated/shared/Facets/FacetDrawerToggle';
import UtilityBar from '../../shared/UtilityBar';

import './ShelfUtilityBar.scss';

export class ShelfUtilityBar extends React.PureComponent {
  render() {
    const { activeFilters, isFetching, pagination, printURL, sortFields, drawerActions } = this.props;

    const activeFilterCount = activeFilters
      .toList()
      .flatten(true)
      .count();

    return (
      <UtilityBar className="cp-shelf-utility-bar">
        <FacetDrawerToggle drawerActions={drawerActions} activeFilterCount={activeFilterCount} />
        <SortDropDown options={sortFields} />
        <div className="pagination-and-print">
          <Pagination autoFocus compact isFetching={isFetching} pagination={pagination} />
          <PrintButton url={printURL} />
        </div>
      </UtilityBar>
    );
  }
}

ShelfUtilityBar.propTypes = {
  activeFilters: ImmutablePropTypes.map.isRequired,
  isFetching: PropTypes.bool.isRequired,
  pagination: ImmutablePropTypes.map.isRequired,
  printURL: PropTypes.string.isRequired,
  sortFields: ImmutablePropTypes.list,
  drawerActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default ShelfUtilityBar;
